import {IMessageAttachment} from "../../modals/ActivityModal/ActivityModal";
import ClickableLink from "../../utilities/ClickableLink";
import {Box, Button, Flex, IconButton, Text} from "@radix-ui/themes";
import ImageComponent from "../../utilities/ImageComponent";
import styles from "../styles/MessageAttachment.module.scss";
import FontAwesome from "../../utilities/FontAwesome";

export function MessageAttachment(props: {
    attachment: IMessageAttachment
}) {
    let content;
    const contentTypeParts = props.attachment.content_type.split("/");
    const type = contentTypeParts[0];
    let subType;
    if (contentTypeParts.length > 1) {
        subType = props.attachment.content_type.split("/")[1];
    }
    switch (type) {
        case "image":
            content = <ImageComponent src={props.attachment.url} alt={props.attachment.name}/>
            break;
        default:
            content = <Box py={"1"} px={"2"}>
                <Flex align={"center"} gapX={"4"}>
                    <IconButton variant={"soft"} size={"1"} asChild>
                        <Box style={{pointerEvents: "none"}}>
                            <FontAwesome prefix={"fas"} name={"fa-paperclip"} />
                        </Box>
                    </IconButton>
                    <Box style={{textAlign: "left"}}>
                        <Text>{props.attachment.name}</Text>
                        {subType && <Box><Text>{subType.toUpperCase()}</Text></Box>}
                    </Box>
                </Flex>
            </Box>
    }
    return <Button asChild variant={"outline"}>
        <Box display={"block"} mt={"1"} mb={"2"} p={"0"} className={styles.container} asChild>
            <ClickableLink href={props.attachment.url}>
                {content}
            </ClickableLink>
        </Box>
    </Button>
}